module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1_5-f46dccd8e2a70d96cbff2cb10d0da686.jpg";